/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Biblio API Adapter
 * API contract for the Biblio API adapter service.

## Adapter principles

This adapter exposes two controlled subsets of the `Biblio API`: a browser-safe subset for end-user clients and a restricted subset for authorized server-to-server clients. Some endpoints are available in both subsets.

- **Bearer-only client auth**: clients send one opaque `bearerAuth` token to the adapter.
  `Biblio API` credentials (`x-api-key` and `Biblio API` bearer token) are handled internally in the adapter.
- **User context derivation**: client-supplied `user_id` is not accepted on user-scoped
  operations. See **Authentication and user identity** below.
- **Automatic user provisioning**: the adapter ensures that authenticated users exist
  in `Biblio API` by internally calling `POST /v1/auth/create-sign-in-token` with
  `create_if_not_exists: true`. The created user is associated with the resolved
  `user_id` and `organization_third_party_id` (see **Authentication and user identity**).
- **Response transparency**: responses include `x-response-source` (`adapter` or `wedobooks`)
  and `x-request-id` for correlation and debugging.

## Authentication and user identity

**Token**

Obtain an OAuth2 access token from [login.bib.dk](https://login.bib.dk) and send it as `Authorization: Bearer <token>`.

**Endpoint access**

Endpoints that read or change a user's loans, reservations, or user data require a token representing the end user, issued via the OAuth2 `authorization_code` grant.

Metadata and sample endpoints can be accessed with either an end-user token or a server-to-server token.

Server-to-server access requires a token issued via the OAuth2 `client_credentials` grant. The OAuth client must be configured with access to the endpoint.

**Identity resolution**

User-scoped endpoints do not accept client-supplied `user_id` or organization ids. Resolve them from login.bib.dk userinfo `attributes` as follows:

1. If both `uniqueId` and `municipality` are present:
   - `user_id` = `uniqueId`
   - `organization_third_party_id` = `municipality`
2. Otherwise, use the Unilogin fallback:
   - `user_id` = `uniloginUniIdHash`
   - `organization_third_party_id` = `uniloginMunicipality`


Unilogin fallback requires an active Unilogin license; otherwise the adapter returns 403 with `User is missing license`.

If identity cannot be resolved, the adapter returns 403 Forbidden.
## Unsupported endpoints in adapter

These endpoints are available in the `Biblio API`, but not in this adapter.

- `POST /v1/auth/sign-in` (used internally)
- `POST /v1/auth/create-user`
- `Webhooks` (Biblio API outbound webhook events)
- `GET /v1/inventory`
- `GET /v1/shelves`
- `GET /v1/onix/{material_id}`
- `GET /v1/onix/pull/alpha`
- `GET /v1/onix/pull/delta/{from_utc_timestamp}`

 * OpenAPI spec version: 1.0.0
 */
import { MaterialTypeAudiobook } from "./materialTypeAudiobook"
import { MaterialTypeEbook } from "./materialTypeEbook"

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImportMaterialType = { ...MaterialTypeEbook, ...MaterialTypeAudiobook } as const
export type ImportMaterialType = (typeof ImportMaterialType)[keyof typeof ImportMaterialType]
